import classnames from 'classnames';
import Title from './parts/title';
import Body from './parts/body';
import styles from './card.module.scss';
import { resolveClassNames } from '../../../helpers/classes';

export type CardProps = {
  children: React.ReactNode;
  noShadow?: boolean;
  cardStyle?: any; // contextStyle type,
  hasHover?: boolean;
  usePointer?: boolean;
  noPadding?: boolean;
  className?: string;
  isLoading?: boolean;
  dataType?: string;
  classString?: string | Array<string>;
  hideOverflow?: boolean;
  noBorderRadius?: boolean;
};

const Card = ({
  children,
  className,
  cardStyle = { mobile: {} },
  hasHover,
  usePointer,
  noPadding,
  noShadow,
  dataType,
  classString,
  hideOverflow,
  noBorderRadius,
}: CardProps) => (
  <div
    data-type={dataType}
    style={context.handleStyle(cardStyle)}
    className={classnames(
      styles.card,
      className,
      resolveClassNames(classString, styles),
      hasHover && styles['is-hover'],
      usePointer && styles['use-pointer'],
      noShadow && styles['no-shadow'],
      noPadding && styles['no-padding'],
      hideOverflow && styles['card--hide-overflow'],
      noBorderRadius && styles['card--no-border-radius'],
    )}
  >
    {children}
  </div>
);

Card.Title = Title;
Card.Body = Body;

export default Card;
